import { render } from "./Pane.vue?vue&type=template&id=995f37d8"
import script from "./Pane.vue?vue&type=script&lang=js"
export * from "./Pane.vue?vue&type=script&lang=js"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__